import solr from './solr';
import gma from './gma/index';
import cda from './cda/index';

export default {
  cda,
  gma,
  solr
};
